import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { ACTION_RULES } from '../../../../helpers/authorization';

import { Content } from '../../../../common/components/layout';
import ResponsiveTable from '../../../../common/components/table/table';
import Loading from "../../../../common/components/ui/loading/loading";

import types from './categoryTypes';
import { getList, remove } from './categoryActions';
import { setLoading } from "../../../../helpers/redux";

const columns = [
	{
		title: "Nome",
		dataIndex: "name",
		key: "name",
	},
	{
		title: "Descrição",
		dataIndex: "description",
		key: "description",
	},

];


class Category extends Component {
	constructor(props) {
		super(props);
		this.props.setLoading(types.CATEGORY_LOADING, true);
		this.props.getList();
		this.state = {
			isVisible: true
		}
	}

	toggleModal = () => {
		this.setState({
			isVisible: !this.state.isVisible
		})
	}

	render() {
		const { pagination } = this.props;
		if (this.props.loading) {
			return (
				<Loading
					isVisible={this.props.loading}
					overlay={false}
                />
			)
		}
		return (
			<Content>
				<ResponsiveTable
					// hasHeader
					customID='_id'
					rowKey={(record)=> record._id}
					columns={columns}
					rows={this.props.categories}
					router={this.props.router}
					onDelete={this.props.remove}
					actions_permissions={ACTION_RULES.can_all}
					pagination={pagination}
				/>
			</Content>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        categories: state.category.list.content,
        pagination: state.category.list.pagination,
        loading: state.category.loading
    }
}
const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ getList, remove, setLoading }, dispatch),
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Category);
